import styled from 'styled-components';

export const ClusterContainer = styled.div`
  position: absolute;
  transform: translate(-50%, -50%);
  pointer-events: auto;
  z-index: 16;
  cursor: pointer;
`;

// Numbered badge for a cluster of crowded point-in-time flags. A rounded square
// filled with the cluster's colour and a white count, echoing the flag pennants
// it stands in for.
export const ClusterBubble = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${props => props.size}px;
  height: ${props => props.size}px;
  padding: 0 ${props => Math.max(2, Math.round(props.size * 0.18))}px;
  border-radius: 4px;
  background: ${props => props.bg || props.theme.colors.blue};
  border: 1.5px solid ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.white};
  font-weight: 700;
  font-size: ${props => Math.max(10, Math.floor(props.size * 0.52))}px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.25);
`;

export const Popover = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, 8px);
  min-width: 220px;
  max-width: 320px;
  background: ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.greyXXD};
  border: 1px solid ${props => props.theme.colors.greyL};
  border-radius: ${props => props.theme.utils.borderRadius};
  padding: 8px;
  box-shadow: 0 6px 16px rgba(0,0,0,0.15);
  z-index: 30;
`;

export const PopoverItem = styled.button`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 8px;
  padding: 8px;
  background: transparent;
  border: none;
  text-align: left;
  border-radius: ${props => props.theme.utils.borderRadius};
  cursor: pointer;

  &:hover {
    background: ${props => props.theme.colors.greyXXXL};
  }
  ${props => props.selected ? `background: ${props.theme.colors.greyXXXL};` : ''}
`;

export const ColorDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${props => props.color};
  display: inline-block;
  border: 1px solid ${props => props.theme.colors.white};
  box-shadow: 0 0 0 1px rgba(0,0,0,0.1);
`;
